/** Request browser-managed password storage after a successful login.
 * Unsupported browsers keep using the form's standard autocomplete attributes.
 * No password is written to application storage. Browser refusal cannot fail login.
 */
export async function saveBrowserLogin({ email, password, remember }, browser = globalThis) {
  if (!remember || !email || !password || !browser.isSecureContext ||
      typeof browser.PasswordCredential !== 'function' ||
      typeof browser.navigator?.credentials?.store !== 'function') return false;

  try {
    const credential = new browser.PasswordCredential({ id: email, password });
    await browser.navigator.credentials.store(credential);
    return true;
  } catch (error) {
    return false;
  }
}
